@if (redirectionLink()) {
  <a data-test="home-redirection-button"
     class="absolute top-6 portrait:right-6 landscape:left-6"
     [href]="redirectionLink()"
  >
  <cds-svg-icon [autofill]="false" name="home"></cds-svg-icon>
  </a>
}
